import { render, staticRenderFns } from "./StudioProductCard.vue?vue&type=template&id=37261eb0&scoped=true&"
import script from "./StudioProductCard.vue?vue&type=script&lang=ts&"
export * from "./StudioProductCard.vue?vue&type=script&lang=ts&"
import style0 from "./StudioProductCard.vue?vue&type=style&index=0&id=37261eb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37261eb0",
  null
  
)

export default component.exports